import { IScreenerListResponse } from 'src/api/types/screeners';
import { timestampToDateFormat } from 'src/utils/timestamp-to-date-format';

export const cellRender = {
    updated_at: (data: IScreenerListResponse) => <span>{timestampToDateFormat(data.updated_at)}</span>,
    created_at: (data: IScreenerListResponse) => <span>{timestampToDateFormat(data.created_at)}</span>,
};
